export default "__VITE_ASSET__B7mow4gE__"